export default "__VITE_ASSET__B90ANX28__"